module.exports = __webpack_public_path__ + "static/media/ipad_12_9_inch_pro_space_grey.1cd8c406.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_12_9_inch_pro_space_grey.jpeg
// module id = 2103
// module chunks = 0